/**
 * A production day's limit from the production calendar (spec 2026-10-18-production-calendar, §6).
 *
 * `critical` for no production, `high` for 1 or 2 batches, the status in words in the badge, and a bank
 * holiday as `neutral`, marked as no block. Colour is never the only signal: the words carry it (WCAG 2.2 AA).
 */
import { Badge } from "@depicomnlbv/platform-ui";

import { REASON_WORDS, type CalendarLimit } from "../api/milkFlow";

export const batchesWord = (n: number) => `${n} batch${n === 1 ? "" : "es"}`;

/** "1 batch · maintenance · planned", or "No production · maintenance · proposed" while only a proposal from the
 *  system sets the limit (SM-2). */
export function calendarWords(c: CalendarLimit): string {
  const limit = c.batches_allowed === 0 ? "No production" : batchesWord(c.batches_allowed);
  const reasons = c.reasons.map((r) => REASON_WORDS[r].toLowerCase()).join(", ");
  return `${limit} · ${reasons} · ${c.planned ? "planned" : "proposed"}`;
}

export function CalendarBadge({ limit, withTitle = false }: { limit: CalendarLimit; withTitle?: boolean }) {
  return (
    <span className="mf-calendar">
      <Badge tone={limit.batches_allowed === 0 ? "critical" : "high"}>{calendarWords(limit)}</Badge>
      {withTitle && limit.titles.length > 0 ? <span className="milk-flow-sub">{limit.titles.join("; ")}</span> : null}
    </span>
  );
}

export function BankHolidayBadge({ title }: { title: string }) {
  return (
    <span className="mf-calendar">
      <Badge tone="neutral">{`${title} · no block`}</Badge>
    </span>
  );
}
